const pattern = {
  /** 手机号 */
  phoneReg: /^((13)|(14)|(15)|(16)|(17)|(18)|(19))\d{9}$/,
  /** 邮箱 */
  emailReg: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
};

export namespace UtilRegExp {
  export function isPhone(value: string): boolean {
    return pattern.phoneReg.test(value);
  }

  export function isEmail(value: string): boolean {
    return pattern.emailReg.test(value);
  }
}



// WEBPACK FOOTER //
// ./src/utils/regExp.ts